import { Box, styled } from '@mui/material';
import Metadata from 'components/metadata';
import { useWorkItemMetadataTabs, useWorkItemMetadataValues } from 'hooks/metadata';
import useWorkItemMetadataRequirements from 'hooks/metadata/useWorkItemMetadataRequirements';
import { useAbstractWorkItemContext } from 'hooks/work-items';
import { GuidOrNumber } from 'models/common';
import { IMetadataOwner, IMetadataTab } from 'models/metadata';
import { IWorkItemOverview } from 'models/work-items';
import { useState } from 'react';

const MetadataContainer = styled(Box)({
    '#parent-metadata-container': {
        width: '60%',
      }
});

const FormTitle = styled(Box)({
    fontSize: '22px',
    marginBottom: '10px',
    fontWeight: 'bold',
    fontFamily: 'Open Sans'
});

type WorkItemMetadataProps = {
    draft?: boolean;
};

const WorkItemMetadata = (props: WorkItemMetadataProps) => {
    const { draft } = props;
    const { workItem, revalidate, updateWorkItemOverview } = useAbstractWorkItemContext();

    const owner: IMetadataOwner = {
        workItemId: workItem?.id ?? 0
    };

    const [refreshKey, setRefreshKey] = useState(0);
    const [ tabs, loadingTabs ] = useWorkItemMetadataTabs(owner, draft);
    const [ requirements, loadingRequirements ] = useWorkItemMetadataRequirements(owner, refreshKey, draft);
    const [ getMetadata, setMetadata ] = useWorkItemMetadataValues(owner, draft);
    const [ loadingValues, setLoadingValues ] = useState<boolean>(false);

    const handleCheckAlert = (tab: IMetadataTab) => {
        if (draft) {
            return requirements?.some(r => {

                // Check if the requirement's tabKey is 'metadata'
                if (r.tabKey !== 'metadata') {
                    return false;
                }
                const tabName = tab.name.toLowerCase();

                const reqTabName = r.groupName.toLowerCase().trim();

                return (reqTabName === tabName) && r.isDone === false;
            }) ?? false;
        }
        else {
            return workItem?.requirements?.some(r => {

                // Check if the requirement's tabKey is 'metadata'
                if (r.tabKey !== 'metadata') {
                    return false;
                }
                const tabName = tab.name.toLowerCase();

                const reqTabName = r.groupName.toLowerCase().trim();

                return (reqTabName === tabName) && r.isDone === false;
            }) ?? false;
        }
    }

    const handleGetMetadata = async (id: GuidOrNumber) => {
        try {
            setLoadingValues(true);
            const values = await getMetadata(id);
            return values?.value;
        } finally {
            setLoadingValues(false);
        }
    };

    const handleSetMetadata = async (id: GuidOrNumber, originalValue: any, newValue: any, isValid: boolean) => {
        if (isValid) {
            const result = await setMetadata(id, originalValue, newValue);
            if (workItem && updateWorkItemOverview) {
                updateWorkItemOverview(workItem as IWorkItemOverview);
            }
            if (revalidate) {
                revalidate();
            }
            setRefreshKey(prev => prev + 1);
            return result?.value;
        }

        return null;
    }

    return (
        <MetadataContainer>
        {
            draft &&
            <FormTitle>
                Metadata
            </FormTitle>
        }
            <Metadata 
                loading={loadingTabs && loadingRequirements}
                loadingValues={loadingValues}
                tabs={tabs}
                onLoadValues={handleGetMetadata}
                onUpdateValue={handleSetMetadata}
                checkAlert={handleCheckAlert}
                refreshKey={refreshKey}
            />
        </MetadataContainer>
    );
};

export default WorkItemMetadata;